// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  loginStatus: {
    data: null,
  },
  getUserTesterlistStatus: { data: null },
  editUserTesterStatus: { data: null },
};
